import React, { useEffect, useRef, useState } from 'react';
import { Alert, Badge, Button, List, Modal, Pagination, Tag } from 'antd';
import { Link } from 'react-router-dom';
import { useAppSelector } from '@hook/index';
import http from '@shared/services/Api';

const UPDATED = 'member-inbox-updated';
const authKey = () => document.cookie.split('; ').find(x=>x.startsWith('userToken=')) || '';
export function InboxLink() {
  const user = useAppSelector((s) => s.authSlice.data);
  const token=authKey();
  const [count, setCount] = useState(0);
  useEffect(() => {
    let alive = true;
    let sequence=0;
    setCount(0);
    const refresh = () => {
      if (!user?.username) return;
      const request=++sequence;
      (http.get('/member-notices/unread') as Promise<any>).then(r => {if(alive&&request===sequence&&authKey()===token)setCount(r.admin_unread);}).catch(() => {});
    };
    refresh();
    window.addEventListener(UPDATED, refresh);
    window.addEventListener('focus', refresh);
    const timer = window.setInterval(refresh, 60000);
    return () => { alive=false; window.clearInterval(timer); window.removeEventListener(UPDATED, refresh); window.removeEventListener('focus', refresh); };
  }, [user?.username,token]);
  return <Link to="/thanh-vien/tin-nhan" style={{display:'inline-flex',alignItems:'center',gap:10,padding:'10px 16px'}}>
    Tin nhắn quản trị <Badge count={count} data-testid="admin-unread" />
  </Link>;
}

export default function MemberInbox() {
  const user=useAppSelector(s=>s.authSlice.data);
  return <MemberInboxSession key={(user?.username||'guest')+authKey()} />;
}
function MemberInboxSession() {
  const token=useRef(authKey()).current;
  const alive=useRef(true);
  useEffect(()=>{alive.current=true;return()=>{alive.current=false;};},[]);
  const [rows,setRows]=useState<any[]>([]), [page,setPage]=useState(1), [total,setTotal]=useState(0);
  const [selected,setSelected]=useState<any>(null), [error,setError]=useState(''), [busy,setBusy]=useState(false);
  useEffect(() => {
    let active=true;
    setBusy(true);setError('');setRows([]);
    (http.get('/member-notices',{params:{page}}) as Promise<any>).then(r=>{if(active&&authKey()===token){setRows(r.messages.data);setTotal(r.messages.total);}})
      .catch(()=>{if(active&&authKey()===token)setError('Không tải được tin nhắn. Vui lòng thử lại.');}).finally(()=>{if(active&&authKey()===token)setBusy(false);});
    return ()=>{active=false;};
  },[page]);
  const open = async (row:any) => {
    if(authKey()!==token||busy)return;
    setSelected(row);setError('');
    if(row.read_at)return;
    try {
      await http.post('/member-notices/'+row.id+'/read');
      if(!alive.current||authKey()!==token)return;
      setRows(list=>list.map(n=>n.id===row.id?{...n,read_at:new Date().toISOString()}:n));
      window.dispatchEvent(new Event(UPDATED));
    } catch {if(alive.current&&authKey()===token)setError('Chưa đánh dấu đã đọc được. Hãy mở lại tin nhắn để thử lại.');}
  };
  if(authKey()!==token)return null;
  return <section style={{padding:20,background:'#fff',color:'#222',minHeight:260}}>
    <h2>Tin nhắn từ ban quản trị</h2>
    {error && <Alert type="error" message={error} />}
    <List loading={busy} dataSource={rows} locale={{emptyText:'Chưa có tin nhắn'}} renderItem={row=><List.Item>
      <Button type="text" style={{height:'auto',textAlign:'left',whiteSpace:'normal',width:'100%'}} onClick={()=>open(row)}>
        <Tag color="red">Quản trị viên</Tag>{!row.read_at && <Tag color="blue">Chưa đọc</Tag>}
        <strong>{row.title}</strong><div style={{fontSize:12}}>{row.created_at}</div>
      </Button>
    </List.Item>} />
    <Pagination current={page} pageSize={20} total={total} onChange={setPage} showSizeChanger={false}/>
    <Modal visible={!!selected} title={selected?.title} onCancel={()=>setSelected(null)} footer={<Button onClick={()=>setSelected(null)}>Đóng</Button>}>
      <p style={{whiteSpace:'pre-wrap',overflowWrap:'anywhere'}}>{selected?.content}</p>
    </Modal>
  </section>;
}
